import React from 'react';
import { withRouter } from 'react-router-dom';
import { from24To12 } from '../../../../../../../../services/utilities';

export default withRouter(class AllChairsItem extends React.Component {
    state = {
        appointmentAllowed: true
    }

    async componentWillMount() {
        let minutesOcuped = 0;

        for (let i = 0; i < this.props.appointments.length - 1; i++) {
            const appointment = this.props.appointments[i];
            const nextAppointment = this.props.appointments[i+1]
            let split = appointment.time.split(":");
            let nextSplit = nextAppointment.time.split(":");
            let hours = Number(split[0]), minutes = Number(split[1]);
            let nextHours = Number(nextSplit[0]), nextMinutes = Number(nextSplit[1]);
            let duration = (appointment.duration + 1)*15;
            minutesOcuped += duration;
            minutes += duration;
            if(minutes >= 60) {
                minutes -= 60;
                hours += 1;
            }

            if(hours != nextHours && minutes != nextMinutes) {
                this.setState({appointmentAllowed: true});
                return;
            }
        }
        var duration;
        if(this.props.appointments[this.props.appointments.length - 1])
            duration = (this.props.appointments[this.props.appointments.length - 1].duration + 1)*15;
        else
             duration = 1*15;
        minutesOcuped += duration;
        if(minutesOcuped/60 == 12)
            this.setState({appointmentAllowed: false});
        else
            this.setState({appointmentAllowed: true});
    }

    appointmentDetails = (appointment) => {
        this.props.history.push(`/appointment-details/${appointment._id}/${appointment.date}/${appointment.chair}`)
    }

    redirect = () => {
        this.props.history.push(`/home/edit-single/${this.props.date.getTime()}/${this.props.chair}`)
    }

    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <p className="card-header-title">
                        Silla {this.props.chair}
                        {` (${this.state.appointmentAllowed ? 'Citas disponibles' : "Sin citas disponibles"})`}
                    </p>
                    <a className="card-header-icon header-button"
                        onClick={this.redirect}
                    >
                        <span className="icon">
                            <i className="fas fa-plus" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
                <div style={{fontSize: "0.8rem"}} className="card-content">
                    {this.props.appointments.length > 0 ?
                    <table className="table is-fullwidth is-hoverable">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Servicio</th>
                                <th>Hora</th>
                                <th>Duración</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.appointments.map(
                            (appointment, index) => {
                                let patient = this.props.patients.find(patient => patient._id == appointment.patient)
                                let diagnostic;
                                if(appointment.old)
                                    diagnostic = {
                                        name: appointment.diagnostic
                                    }
                                else
                                    diagnostic = this.props.diagnostics.find(diagnostic => diagnostic._id == appointment.diagnostic)

                                return (
                                    <tr key={index} onClick={() => this.appointmentDetails(appointment)}>
                                        <td>{`${patient.name} ${patient.lastname}`}</td>
                                        <td>{diagnostic.name}</td>
                                        <td>{from24To12(appointment.time)}</td>
                                        <td>{(appointment.duration + 1)*15} min</td>
                                    </tr>
                                )
                            }
                            )}
                        </tbody>
                    </table> :
                    <p>No hay citas...</p>}
                </div>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/all-chairs-item/index.js